document.addEventListener("DOMContentLoaded", function () {
  const searchBtn = document.querySelector(".header__search-btn");
  const searchPopup = document.querySelector("#search-popup");
  const searchPopupContent = document.querySelector(".search-popup__content");

  searchBtn.addEventListener("click", function () {
    searchPopup.classList.add("opened");
  });

  searchPopup.addEventListener("click", function (event) {
    if (
      searchPopup.classList.contains("opened") &&
      !searchPopupContent.contains(event.target) &&
      event.target !== searchBtn
    ) {
      searchPopup.classList.remove("opened");
    }
  });
});
